import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import AppRoutes from "components/router/AppRoutes";

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'react-toastify/dist/ReactToastify.css';
import "./styles/main.scss";

import GeneralUtils from "GeneralUtils";

import { ToastContainer } from "react-toastify";

GeneralUtils.clearGlobalVars();

ReactDOM.render(
  <>
  <Router>
    <AppRoutes />
  </Router>

   <ToastContainer
      position="bottom-right"
      newestOnTop
      hideProgressBar
      className="mb40" />
   </>,
  document.getElementById("root")
);







